module.exports = __webpack_public_path__ + "static/media/9.7f37fe45.jpg";